import { useEffect, useRef } from 'react';

export const useIntersectionObserver = <T extends HTMLElement>(callback: () => void) => {
  const observerTarget = useRef<T>(null);

  useEffect(() => {
    const currentObserverTarget = observerTarget.current;

    const observer = new IntersectionObserver((entries) => {
      entries?.forEach((entry) => {
        if (entry?.isIntersecting && currentObserverTarget) {
          observer.unobserve(currentObserverTarget);
          callback();
        }
      });
    });

    if (currentObserverTarget) {
      observer.observe(currentObserverTarget);
    }

    return () => {
      if (currentObserverTarget) {
        observer.unobserve(currentObserverTarget);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [observerTarget]);

  return {
    observerTarget,
  };
};
